import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage, throwSuccessMessage } from '../../../utils/Errors'
import { fetchProducts } from './fetchProducts'
import { getUrlWithVersion } from '../../../api/api'

export const renameProduct = createAsyncThunk<
    { guid: string },
    { guid: string; name: string },
    ThunkConfig<string>
>('productsSlice/renameProduct', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
        dispatch,
    } = thunkAPI

    const { guid, name } = args

    try {
        await api.put(getUrlWithVersion(`/products/${guid}/name`), { name })

        dispatch(fetchProducts({ isInitialFetch: false }))
        localStorage.setItem(`${guid}-productName`, name)
        throwSuccessMessage('Success!')

        return { guid }
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to rename product')
    }
})
